import React from 'react';

function RenderGeneralDetails({ data, id }) {
  return (
    <div
      className="gnrl-detail-section smart-tag-bdy recrd-nt-rw content-line-break"
      id={'sectionVal_' + id}
      key={id}
    >
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Service code:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.procName &&
            data?.genDetail?.procName.map((data, i) => (
              <div key={data.code}>
                <div>{data.procName}</div>
                <div>
                  <span
                    style={{
                      color: 'black',
                      marginRight: 5,
                    }}
                  >
                    Unit:
                  </span>
                  {data?.unit && data?.unit.toString().padStart(2, '0')}
                </div>
              </div>
            ))}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Modifier:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.modifier?.split(',')?.join(', ')}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Diagnosis:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.probText?.map((data, i) => (
            <div key={i}>{data}</div>
          ))}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Supervisor:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.supervisor}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Resource:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.resource}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Date:</span>
        <span className="frst-sec-val sec-colr">{data?.genDetail?.dos}</span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Present:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.present}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Type:</span>
        <span className="frst-sec-val sec-colr">{data?.genDetail?.type}</span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Location:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.location}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Time:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.consultTime}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Duration:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.duration}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl">Referrer:</span>
        <span className="frst-sec-val sec-colr">
          {data?.genDetail?.referrer}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span className="frst-sec-lbl"></span>

        <span className="frst-sec-val sec-colr">
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.qcodeDetail
                ? data?.genDetail?.qcodeDetail
                : '',
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.patientLocation
                ? data?.genDetail?.patientLocation
                : '',
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.locationAddress
                ? data?.genDetail?.locationAddress
                : '',
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.providerLocation
                ? data?.genDetail?.providerLocation
                : '',
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.pfa_provider_loc
                ? data?.genDetail?.pfa_provider_loc
                : '',
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: data?.genDetail?.pfc_telemedicine
                ? data?.genDetail?.pfc_telemedicine
                : '',
            }}
          />
        </span>
      </div>
    </div>
  );
}

export default RenderGeneralDetails;
